import { useEffect, useCallback } from 'react';
import websocketService from '../services/websocketService';

export const useWebSocket = (dataType, onDataChange) => {
  const handleDataChange = useCallback((data) => {
    console.log(`🔔 Notification ${dataType}:`, data);
    if (onDataChange) {
      onDataChange(data);
    }
  }, [dataType, onDataChange]);

  useEffect(() => {
    // S'abonner aux notifications
    // La connexion est déjà gérée par App.js au démarrage
    websocketService.onDataChange(dataType, handleDataChange);

    // Nettoyage lors du démontage du composant
    return () => {
      websocketService.offDataChange(dataType, handleDataChange);
    };
  }, [dataType, handleDataChange]);

  return {
    isConnected: websocketService.isConnected(),
    reconnect: websocketService.reconnect.bind(websocketService)
  };
};

// Hook spécialisé pour les souscriptions
export const useSouscriptionUpdates = (onUpdate) => {
  return useWebSocket('souscription', onUpdate);
};

// Hook spécialisé pour les logements
export const useLogementUpdates = (onUpdate) => {
  return useWebSocket('logement', onUpdate);
};

// Hook spécialisé pour les statistiques
export const useStatisticsUpdates = (onUpdate) => {
  return useWebSocket('statistics', onUpdate);
};